import { Link } from 'react-router-dom'
import { useState } from 'react'

const OPEN_SIGNUP = import.meta.env.VITE_OPEN_SIGNUP !== 'false'

const WaitlistForm = () => {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!email) return
    setSubmitted(true)
  }

  if (submitted) {
    return (
      <div className="text-center">
        <div className="text-4xl mb-4">🎉</div>
        <p className="text-white font-semibold text-lg">You're on the list!</p>
        <p className="text-white/70 text-sm mt-2">We'll email you at <span className="font-medium text-white">{email}</span> when we open up.</p>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" id="waitlist">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        className="flex-1 bg-white/10 border border-white/20 text-white placeholder-white/40 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-white/50 focus:bg-white/20 transition-all"
      />
      <button
        type="submit"
        className="bg-white text-primary font-semibold text-sm px-6 py-3 rounded-xl hover:bg-white/90 transition-colors whitespace-nowrap"
      >
        Join waitlist
      </button>
    </form>
  )
}

export const FinalCTASection = () => (
  <section className="py-28 px-4 bg-primary text-white text-center relative overflow-hidden">
    {/* Background decoration */}
    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-white/5 rounded-full blur-3xl pointer-events-none" />

    <div className="relative max-w-2xl mx-auto reveal">
      <p className="text-white/60 text-sm font-semibold uppercase tracking-wider mb-4">Ready to start?</p>
      <h2 className="font-display text-3xl sm:text-5xl font-bold mb-6 leading-tight">
        Your household,<br />
        finally in sync.
      </h2>
      <p className="text-white/70 text-base mb-10 max-w-lg mx-auto">
        Join thousands of households using DoorChart to stay organised, reduce friction,
        and spend less time managing — and more time together.
      </p>

      {OPEN_SIGNUP ? (
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/signup"
            className="w-full sm:w-auto bg-white text-primary font-semibold text-sm px-8 py-4 rounded-2xl hover:bg-white/90 transition-all shadow-xl"
          >
            Start free trial — no card needed
          </Link>
          <Link
            to="/login"
            className="w-full sm:w-auto border border-white/30 text-white font-semibold text-sm px-8 py-4 rounded-2xl hover:bg-white/10 transition-all"
          >
            Sign in
          </Link>
        </div>
      ) : (
        <WaitlistForm />
      )}

      <p className="text-white/40 text-xs mt-6">
        Free plan available · No credit card · Cancel anytime
      </p>
    </div>
  </section>
)
